"use client";

import Box from "@mui/material/Box";
import type { PageChromeBlockProps } from "../pageChromeTypes";

export function LayoutDivider({ width }: PageChromeBlockProps["Divider"]) {
  return (
    <Box
      component="hr"
      sx={{
        width: "100%",
        maxWidth: width === "narrow" ? "600px" : undefined,
        mx: "auto",
        my: 0,
        border: 0,
        borderTop: "1px solid",
        borderColor: "dream.borderColor",
      }}
    />
  );
}

const spacerHeights = { small: 16, medium: 32, large: 64 };

export function LayoutSpacer({ size, heightPx, spacingUnit }: PageChromeBlockProps["Spacer"]) {
  const height = heightPx ?? spacerHeights[size];
  return (
    <Box
      aria-hidden
      sx={{
        height: spacingUnit === "rem" ? `${height / 16}rem` : height,
        width: "100%",
        flexShrink: 0,
      }}
    />
  );
}
